import { useSelector } from '../state/store'

export function useIsImpersonating(): boolean {
  const user = useSelector((state) => state.user)
  if (!user.user) {
    return false
  }
  return user.user.firebaseUser.uid !== user.user.fuid
}
